import { toReadableTotal } from '../../utils/orderUtils';

export default function OrderCost({ order}) {
    if (!order) {return null};

    return (
        <div className="table-container">
            <table className="table">
                <tbody>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Subtotal:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)'
                        }}>
                            ${toReadableTotal(order.cost.subtotal)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Shipping:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)'
                        }}>
                            ${toReadableTotal(order.cost.shipping)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Tax:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)'
                        }}>
                            ${toReadableTotal(order.cost.tax)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Discount:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--error-color)'
                        }}>
                            -${toReadableTotal(order.cost.discount)}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-bold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px',
                            fontSize: 'var(--font-size-lg)'
                        }}>
                            Total:
                        </td>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-bold)', 
                            color: 'var(--success-color)',
                            fontSize: 'var(--font-size-lg)'
                        }}>
                            ${toReadableTotal(order.cost.total)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    )
}